import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M16.289 4.008v3.703h3.735c-1.125-1.172-2.563-2.68-3.735-3.703z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.398 8.602V3.75h-5.391v1.62c1.453 1.668 3.117 3.096 4.594 4.737v7.541h5.649V8.601h-4.852z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.164 11.235V6.351H3.75V20.25h10.008v-8.982c-1.477-.075-3.071-.011-4.594-.032z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.008 6.586v3.774h3.765a77.398 77.398 0 00-3.765-3.774z"
})), 'Copy');